import PropTypes from 'prop-types';
import React from 'react';
import { StyledBulletPoint } from './style/BulletPoint.styled';

export const BulletPoint = ({ text }) => {
    return <StyledBulletPoint>{text}</StyledBulletPoint>;
};

BulletPoint.propTypes = {
    text: PropTypes.string
};
